const LANGUAGES = [
{ label: 'Bahasa (Malaysia)', value: 'Bahasa (Malaysia)' },
{ label: 'Chinese (Mandarin)', value: 'Chinese (Mandarin)' },
{ label: 'Chinese (Cantonese)', value: 'Chinese (Cantonese)' },
{ label: 'English (Cantonese)', value: 'English (Cantonese)' },
{ label: 'English (Mandarin)', value: 'English (Mandarin)' },
{ label: 'English (Australian)', value: 'English (Australian)' },
{ label: 'English (Neutral - Mid Trans Atlantic)', value: 'English (Neutral - Mid Trans Atlantic)' },
{ label: 'English (British)', value: 'English (British)' },
{ label: 'English (Indian)', value: 'English (Indian)' },
{ label: 'English (Irish)', value: 'English (Irish)' },
{ label: 'English (Scottish)', value: 'English (Scottish)' },
{ label: 'English (North American)', value: 'English (North American)' },
{ label: 'English (Bahasa)', value: 'English (Bahasa)' },
{ label: 'English (Japan)', value: 'English (Japan)' },
{ label: 'English (Filipino)', value: 'English (Filipino)' },
{ label: 'English (Malaysian)', value: 'English (Malaysian)' },
{ label: 'Hindi (Indian)', value: 'Hindi (Indian)' },
{ label: 'Indonesian (Bahasa)', value: 'Indonesian (Bahasa)' },
{ label: 'Japanese (Japan)', value: 'Japanese (Japan)' },
{ label: 'Malay (Malaysian)', value: 'Malay (Malaysian)' },
{ label: 'Tagalog (Filipino)', value: 'Tagalog (Filipino)' }];


export default LANGUAGES;